import { z } from "zod";

import {
  memberApprovalPolicySchema, memberRequestSchema, memberReviewersSchema, memberDeskRequestSchema, memberDeskResponseSchema,
} from "./api.generated";

// Response validators are generated from the operations contract; UI vocabularies derive from them.
export { memberApprovalPolicySchema, memberRequestSchema, memberReviewersSchema, memberDeskRequestSchema, memberDeskResponseSchema };
export const memberRequestStatusSchema = memberRequestSchema.shape.status;
export type MemberRequestStatus = z.infer<typeof memberRequestStatusSchema>;
export type MemberApprovalPolicy = z.infer<typeof memberApprovalPolicySchema>;
export type MemberRequest = z.infer<typeof memberRequestSchema>;
export const memberApprovalSearchSchema = z.object({
  memberStatus: memberRequestStatusSchema.optional(),
  memberCursor: z.string().uuid().optional(),
});
export type MemberReviewer = z.infer<typeof memberReviewersSchema>["items"][number];
export const memberDecisionSchema = z.enum(["approve", "reject", "revoke"]);
export type MemberDecision = z.infer<typeof memberDecisionSchema>;
export const memberDecisionInputSchema = z.object({
  requestId: z.string().uuid(), decision: memberDecisionSchema,
  note: z.string().refine((value) => new TextEncoder().encode(value).length <= 500 && !value.includes("\0"), "Shorten the note and remove unsupported characters."),
});
export const memberPolicyInputSchema = memberApprovalPolicySchema.superRefine((policy, context) => {
  if (policy.reviewer_admin_ids.length > 20 || new Set(policy.reviewer_admin_ids).size !== policy.reviewer_admin_ids.length) context.addIssue({ code: "custom", message: "Choose up to 20 distinct reviewers.", path: ["reviewer_admin_ids"] });
});

// The membership desk has its own workflow and authorization. It does not add
// membership to the access/recovery engine's closed request-kind union.
export const memberDeskSearchSchema = z.object({
  status: memberRequestStatusSchema.optional(),
  organization_id: z.string().uuid().optional(),
  request_id: z.string().uuid().optional(),
  cursor: z.string().uuid().optional(),
});
export type MemberDeskSearch = z.infer<typeof memberDeskSearchSchema>;
export type MemberDeskRequest = z.infer<typeof memberDeskRequestSchema>;
